const { default: CategoriesTable } = require("./components/CategoriesTable");

const CategoriesComponent = () => {
  return <CategoriesTable />;
};
export default CategoriesComponent;
